export const CENTS_PER_POINT = 10;

export function pointsToDollars(points: number): number {
    return (Math.floor(points) * CENTS_PER_POINT) / 100;
}

export function allocateFlooredCents(rowCents: number[], totalPoints: number): number[] {
    const floored = rowCents.map(cents => Math.floor(cents / CENTS_PER_POINT) * CENTS_PER_POINT);
    let remainingCents = Math.floor(totalPoints) * CENTS_PER_POINT - floored.reduce((sum, cents) => sum + cents, 0);
    const byLargestRemainder = rowCents
        .map((cents, index) => ({index, remainder: cents - floored[index]}))
        .filter(row => row.remainder > 0)
        .sort((rowA, rowB) => rowB.remainder - rowA.remainder);
    for (const row of byLargestRemainder) {
        if (remainingCents < CENTS_PER_POINT) {
            break;
        }
        floored[row.index] += CENTS_PER_POINT;
        remainingCents -= CENTS_PER_POINT;
    }
    return floored;
}
